import Api from '../../services';

export const createBooking = (data) => {
  return (dispatch) => {
    return Api.booking.createBooking(data).then((response) => {
      dispatch({
        type: 'CREATE_BOOKING',
        data: response,
      });
      return response;
    });
  };
};

export const updateBooking = (bookingId, data) => {
  return (dispatch) => {
    return Api.booking.updateBooking(bookingId, data).then((response) => {
      dispatch({
        type: 'UPDATE_BOOKING',
        data: response,
      });
      return response;
    });
  };
};

export const submitBooking = (bookingId) => {
  return (dispatch) => {
    return Api.booking.submitBooking(bookingId).then((response) => {
      dispatch({
        type: 'SUBMIT_BOOKING',
        data: response,
      });
      return response;
    });
  };
};

export const getBooking = (bookingId) => {
  return (dispatch) => {
    return Api.booking.getBooking(bookingId).then((response) => {
      dispatch({ type: 'GET_BOOKING', data: response });
      return response;
    });
  };
};

export const cancelBooking = (bookingId, data) => {
  return (dispatch) => {
    return Api.booking.cancelBooking(bookingId, data).then((response) => {
      dispatch({
        type: 'CANCEL_BOOKINGS',
        data: response,
      });
      return response;
    });
  };
};
